
const wrapper = document.querySelector('.carousel-wrapper');
const wrapper2 = document.querySelector('.carousel2-wrapper');
const wrapper3 = document.querySelector('.carousel3-wrapper');
const primaryCont = document.querySelector('.caros')
let slides = [];
let slides2 = [];
let slides3 = [];
let index = 0;
let index2 = 0;
let index3 = 0;

let inter;
let inter2;
let inter3;

$(document).ready(function(){
    
    getImages();
    
 
    inter = setInterval(update, 5000, 1);
    inter2 = setInterval(update2, 5000, 1);
    inter3 = setInterval(update3, 5000, 1);

})

function update(direct) {
    
    if (direct == 1) {
    index = (index + 1) % slides.length;
    }
    else {
        index = (index - 1 + slides.length) % slides.length;
    }
   
    wrapper.style.transform = `translateX(-${index * 100}%)`;

    clearInterval(inter);
    inter = setInterval(update, 5000, 1);

}

function update2(direct) {
    
    if (direct == 1) {
    index2 = (index2 + 1) % slides2.length;
    }
    else {
        index2 = (index2 - 1 + slides2.length) % slides2.length;
    }
   
    wrapper2.style.transform = `translateX(-${index2 * 100}%)`;

    clearInterval(inter2);
    inter2 = setInterval(update2, 5000, 1);
}

function update3(direct) {
    
    if (direct == 1) {
    index3 = (index3 + 1) % slides3.length;
    }
    else {
        index3 = (index3 - 1 + slides3.length) % slides3.length;
    }
    wrapper3.style.transform = `translateX(-${index3 * 100}%)`;

    clearInterval(inter3);
    inter3 = setInterval(update3, 5000, 1);
}

async function getImages() {
    
    const caroParent = document.querySelector(".carousel-wrapper");
    const caroParent2 = document.querySelector(".carousel2-wrapper");
    const caroParent3 = document.querySelector(".carousel3-wrapper");
    const slideTemp = document.querySelector("#slideTemp");

    console.log(caroParent);

    const response = await fetch("https://ecgce-backend.uzairkhan.workers.dev/api/storefront/get-foc-images");
    if (!response.ok) {
        console.log("YOU FAILED");
        return;
    }
    const data = await response.json();
    
    if (data['Picks'].length == 0) {
        while (primaryCont.firstChild) {
        primaryCont.removeChild(primaryCont.lastChild);
        }
        notice = document.createElement('h1');
        notice.textContent = "Check Back Later for This Week's FOC Picks";
        notice.style.textAlign = "center";
        primaryCont.appendChild(notice);
        primaryCont.style.justifyContent = "center";

        return;
    }      
    
    console.log("DATA")
    console.log(data)
    const picksFiles = data['Picks'];
    picksFiles.forEach(filename => {
        let slideClone = slideTemp.content.cloneNode(true);
        console.log(slideClone);
        let slideImg = slideClone.querySelector('img')
        let slideA = slideClone.querySelector('a')
        slideImg.src= 'https://ecgce-backend.uzairkhan.workers.dev/api/storefront/get-image/FOC Picks/'+filename['src'];
        slideA.href = "https://www.ecgce.com/products/"+ filename['link']
        slides.push(slideClone)
        caroParent.appendChild(slideClone);
     
    })

    const honorFiles = data['Honor'];
    honorFiles.forEach(filename => {
        let slideClone2 = slideTemp.content.cloneNode(true);
        let slideImg2 = slideClone2.querySelector('img')
        let slideA = slideClone2.querySelector('a')
        slideImg2.src= 'https://ecgce-backend.uzairkhan.workers.dev/api/storefront/get-image/Honorable Mentions/'+filename['src'];
        slideA.href = "https://www.ecgce.com/products/"+ filename['link']
        slides2.push(slideClone2)
        caroParent2.appendChild(slideClone2);
     
    })

    const loveFiles = data['Love'];
    loveFiles.forEach(filename => {
        let slideClone3 = slideTemp.content.cloneNode(true);
        let slideImg3 = slideClone3.querySelector('img')
        let slideA = slideClone3.querySelector('a')
        slideImg3.src= 'https://ecgce-backend.uzairkhan.workers.dev/api/storefront/get-image/Covers We Love/'+filename['src'];
        slideA.href = "https://www.ecgce.com/products/"+ filename['link']
        slides3.push(slideClone3)
        caroParent3.appendChild(slideClone3);
     
    })


    

        


}